import { render } from "./TanaoroshiSaiPage.vue?vue&type=template&id=01b12b11"
import script from "./TanaoroshiSaiPage.vue?vue&type=script&lang=js"
export * from "./TanaoroshiSaiPage.vue?vue&type=script&lang=js"

import "./TanaoroshiSaiPage.vue?vue&type=style&index=0&id=01b12b11&lang=css"

import exportComponent from "/codebuild/output/src999357143/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__